import { Injectable } from '@angular/core';
import { Observable, Subscriber } from 'rxjs';
import { parse } from 'papaparse';

interface CdrFile {
  cdrRecordType: string;
}

@Injectable()
export class CdrValidationService {
  validateCdrFile(file: File): Observable<boolean> {
    const chunkSize = 100000; // bytes = 0.1mb
    const offset = 0;

    return new Observable<boolean>((subscriber) => {
      const r = new FileReader();
      const blob = file.slice(offset, chunkSize + offset);
      r.onload = (e) => {
        if (e.target.error == null) {
          this._parseFile(e.target.result).subscribe((isValid) => {
            subscriber.next(isValid);
            subscriber.complete();
          });
        } else {
          subscriber.next(false);
          subscriber.complete();
        }
      };
      r.readAsText(blob);
    });
  }

  private _parseFile(result: any): Observable<boolean> {
    let parsedAnyLines = false;
    return new Observable((subscriber: Subscriber<boolean>) => {
      parse<CdrFile>(result, {
        header: true,
        skipEmptyLines: true,
        step: (row, parser) => {
          parsedAnyLines = true;
          const data = row.data as unknown as CdrFile;
          const cdrRecordType = data.cdrRecordType;

          if (parseInt(cdrRecordType) !== 1) {
            parser.abort();
          }
        },
        complete: (results) => {
          const valid = parsedAnyLines && !results.errors.length && !results.meta.aborted;
          subscriber.next(valid);
          subscriber.complete();
        },
      });
    });
  }
}
